<!-- platform -->
<div class="section section-platform">

  <div class="container-section">

    <div class="container-fluid">

      <div class="row align-content-stretch">

        <div class="col-12 col-sm-6 flex-fill align-self-center column-left">

          <div class="content">

            <p class="career-text">
              {{'Your career starts here!' | translate}}
            </p>

            <h2 class="alternate-heading" *ngIf="locale.getCurrentLanguage() == 'en'">
              {{'How does our'}} <span class="text-primary">{{'platform'}}</span> {{'work'}}?
            </h2>

            <h2 class="alternate-heading" *ngIf="locale.getCurrentLanguage() == 'nl'">
              {{'Hoe werkt ons'}} <span class="text-primary">{{'platform'}}?</span>
            </h2>

            <h2 class="alternate-heading" *ngIf="locale.getCurrentLanguage() == 'de'">
              {{'Wie funktioniert unsere'}} <span class="text-primary">{{'Plattform'}}?</span>
            </h2>

            <h2 class="alternate-heading" *ngIf="locale.getCurrentLanguage() == 'fr'">
              {{'Comment fonctionne notre'}} <span class="text-primary">{{'platform'}}</span>?
            </h2>

            <h2 class="alternate-heading" *ngIf="locale.getCurrentLanguage() == 'pt'">
                {{'Como funciona nossa'}} <span class="text-primary">{{'plataforma'}}?</span>
            </h2>

            <p class="info-text">
              {{'View the video here with explanation of the platform' | translate}}
            </p>

            <button type="button" class="btn btn-primary btn-special" (click)="Register()">
              {{'Start here' | translate}}
            </button>

          </div>

        </div>

        <div class="col-12 col-sm-6 column-right">

          <div class="company-instruction-video">

            <div class="bg-wrapper">

              <a class="video-play-overlay cursor-pointer" (click)="videoService.openVideo('https://www.youtube.com/watch?v=7nuGFBU_1rU')">
                <img src="assets/img/hoewerkthet-thumb.png" class="shadow" />
              </a>

            </div>

          </div>

        </div>

      </div>

    </div>

  </div>

</div>

<!-- start career -->
<div class="section section-startcareer bg-half-brand">

  <div class="container-section">

    <div class="row">
      <div class="col-12 text-center">
        <h2 class="alternate-heading">
          {{'Start here your career!' | translate}}
        </h2>
        <h2 class="alternate-heading text-primary">
          {{'View our most recent vacancies.' | translate}}
        </h2>
      </div>
    </div>

    <div class="slider-jobs">

      <!-- desktop view -->
      <span class="d-none d-sm-block">
         <ngb-carousel class="carousel-primary" [showNavigationArrows]="false" [showNavigationIndicators]="true" *ngIf="jobSlider.slides_desktop">
          <ng-template *ngFor="let slide of jobSlider.slides_desktop" ngbSlide>

            <div class="row">
              <div class="col-12 col-sm-3" *ngFor="let slideItem of slide">
                <a class="job-link" [routerLink]="'/jobs/' + slideItem.id">
                   <div class="img-wrapper company-logo">
                      <img class="img-fluid image" [src]="(!empty(slideItem['trademark']) && !empty(slideItem['trademark']['avatarUri']) ? slideItem['trademark']['avatarUri'] : slideItem['company']['avatarUri'])" />
                   </div>
                  <div class="job-caption">
                    <h3 class="job-date" *ngIf="slideItem.date">{{slideItem['createdOn'] | date: "dd-MM-YYYY"}}</h3>
                    <h3 class="job-title" *ngIf="slideItem.title">
                      {{slideItem.title.length > 16 ? (slideItem.title | slice:0:16) + '...' : slideItem.title }}
                    </h3>
                  </div>

                </a>
              </div>
            </div>
          </ng-template>
        </ngb-carousel>
      </span>

      <!-- mobile view -->
      <span class="d-block d-sm-none">
       <ngb-carousel class="carousel-primary" [showNavigationArrows]="false" [showNavigationIndicators]="true" *ngIf="jobSlider.slides_mobile">
        <ng-template *ngFor="let slide of jobSlider.slides_mobile" ngbSlide>

          <div class="row">
            <div class="col-12 col-sm-3" *ngFor="let slideItem of slide">
               <a class="job-link" [routerLink]="'/jobs/' + slideItem.id">
                 <div class="img-wrapper company-logo">
                   <img class="img-fluid image" [src]="(!empty(slideItem['trademark']) && !empty(slideItem['trademark']['avatarUri']) ? slideItem['trademark']['avatarUri'] : slideItem['company']['avatarUri'])" />
                 </div>
                <div class="job-caption">
                  <h3 class="job-date" *ngIf="slideItem.date">{{slideItem['createdOn'] | date: "dd-MM-YYYY"}}</h3>
                  <h3 class="job-title" *ngIf="slideItem.title">
                    {{slideItem.title.length > 16 ? (slideItem.title | slice:0:16) + '...' : slideItem.title }}
                  </h3>
                </div>

              </a>
            </div>
          </div>
        </ng-template>
      </ngb-carousel>
      </span>

    </div>

    <div class="row row-button-more">
      <div class="col-12 text-center">

        <a class="btn btn-light btn-white btn-special" routerLink="/vacancies">
            {{'View all vacancies' | translate}}
        </a>

      </div>
    </div>

  </div>

</div>

<!-- testimonials -->
<div class="section section-testimonials bg-white">

  <div class="container-fluid">

    <div class="container-section">

      <div class="row">
        <div class="col-12 text-center">

          <img class="testimonial-quote" src="assets/img/testimonial-quote.png">

          <div class="slider-testimonials">
            <ngb-carousel [showNavigationArrows]="true" [showNavigationIndicators]="false" *ngIf="testimonialSlider.slides">
              <ng-template *ngFor="let slide of testimonialSlider.slides" ngbSlide>

                <div class="row">

                  <div class="col-12">
                    <div class="item-wrapper">

                      <div class="item-content ck-content" [innerHTML]="slide.content"></div>
                      <h3 class="item-title text-primary alternate-heading">{{slide.title}}</h3>
                      <h4 *ngIf="slide.testimonialName" class="item-subtitle">{{slide.testimonialName}}</h4>

                    </div>
                  </div>

                </div>

              </ng-template>
            </ngb-carousel>
          </div>


        </div>
      </div>



    </div>

  </div>

</div>

<!-- contact -->
<div class="section section-contact bg-white">

  <div class="container-section">

    <div class="container-fluid">

      <div class="row">

        <div class="col-6 col-sm-6 column-left">

          <div class="button-box button-box-brand">

            <h3 class="special-heading">{{'Sign up' | translate}}</h3>

            <a (click)="Register()" class="btn btn-special btn-default btn-white btn-lg btn-flat btn-rounded">
              {{'Start here!' | translate}}
            </a>

          </div>

        </div>

        <div class="col-6 col-sm-6 column-right">

          <div class="button-box button-box-black">

            <h3 class="special-heading">{{'Contact' | translate}}</h3>

            <a href="mailto:info@meettheyoungsters.nl" class="btn btn-default btn-special btn-white btn-lg btn-flat btn-rounded">
              {{'Mail us!' | translate}}
            </a>

          </div>

        </div>

      </div>

    </div>

  </div>

</div>

<!-- companies -->
<div class="section section-companies">

  <div class="container-section">

    <div class="slider-companies">

      <!-- desktop view -->
      <span class="d-none d-sm-block">
         <ngb-carousel [showNavigationArrows]="false" [showNavigationIndicators]="true" *ngIf="companySlider.slides_desktop">
          <ng-template *ngFor="let slide of companySlider.slides_desktop" ngbSlide>

            <div class="row">
              <div class="column-5 col" [ngClass]="{'d-none': !slideItem['avatarUri']}" *ngFor="let slideItem of slide">
                 <a class="company-link align-self-center" [routerLink]="'/companies/' + slideItem.id">
                   <div class="img-wrapper company-logo">
                     <img class="img-fluid image filter-grayscale" [src]="slideItem['avatarUri']" />
                   </div>
                </a>
              </div>
            </div>

          </ng-template>
        </ngb-carousel>
      </span>

      <!-- mobile view -->
      <span class="d-block d-sm-none">
         <ngb-carousel [showNavigationArrows]="false" [showNavigationIndicators]="true" *ngIf="companySlider.slides_mobile">
          <ng-template *ngFor="let slide of companySlider.slides_mobile" ngbSlide>

             <div class="row">
              <div class="col-6" [ngClass]="{'d-none': !slideItem['avatarUri']}" *ngFor="let slideItem of slide">
                 <a class="company-link align-self-center" [routerLink]="'/companies/' + slideItem.id">
                   <div class="img-wrapper company-logo">
                     <img class="img-fluid image filter-grayscale" [src]="slideItem['avatarUri']" />
                   </div>
                </a>
              </div>
            </div>

          </ng-template>
        </ngb-carousel>
      </span>

    </div>


    <div class="row row-button-more">

      <div class="col-12 text-center">

        <a class="btn btn-primary btn-special" routerLink="/our-network">
          {{'View all companies' | translate}}
        </a>

      </div>
    </div>

  </div>

</div>

<!-- events -->
<div class="section section-events container-fluid">

  <a class="section-anchor" name="section-events"></a>

  <div class="row align-content-stretch">

    <div class="col-12 col-sm-4 col-xl-6 column-left flex-fill align-self-center">

      <h3 class="alternate-heading align-self-stretch justify-content-center d-flex text-center">
        {{'Events' | translate}}
      </h3>

    </div>

    <div class="col-12 col-sm-8 col-xl-6 column-right align-items-stretch">

      <div class="jumbotron jumbotron-events d-flex align-self-center">

        <div class="slider-events">

          <!-- desktop view -->
          <span class="d-none d-lg-block">
             <ngb-carousel [showNavigationArrows]="false" [showNavigationIndicators]="true" *ngIf="eventSlider.slides_desktop">
              <ng-template *ngFor="let slide of eventSlider.slides_desktop" ngbSlide>

                <div class="row">
                  <div class="col-12 col-sm-4" *ngFor="let slideItem of slide">
                    <a class="event-link" [routerLink]="'events/' + slideItem.id">
                      <div class="event-caption">
                      <h3 class="event-date" *ngIf="slideItem.eventDate || slideItem.eventPeriodDescription">{{(slideItem.eventPeriodDescription ? slideItem.eventPeriodDescription : slideItem.eventDate | date : "dd-MM-YYYY")}}</h3>
                      <h3 class="event-title" *ngIf="externalpageService.getTranslatedTitle(slideItem)">{{externalpageService.getTranslatedTitle(slideItem) | excerpt:30}}</h3>
                      <div class="event-content" *ngIf="externalpageService.getTranslatedContent(slideItem)">
                        <span [innerHTML]="externalpageService.getTranslatedContent(slideItem) | excerpt:120 | striphtml"></span>
                      </div>
                    </div>
                    </a>
                  </div>
                </div>
              </ng-template>
            </ngb-carousel>
          </span>

          <!-- mobile view -->
          <span class="d-block d-lg-none">
             <ngb-carousel [showNavigationArrows]="false" [showNavigationIndicators]="true" *ngIf="eventSlider.slides_mobile">
              <ng-template *ngFor="let slide of eventSlider.slides_mobile" ngbSlide>

                <div class="row">
                  <div class="col-12" *ngFor="let slideItem of slide">
                     <a class="event-link" [routerLink]="'events/' + slideItem.id">
                      <div class="event-caption">
                      <h3 class="event-date" *ngIf="slideItem.eventDate || slideItem.eventPeriodDescription">{{(slideItem.eventPeriodDescription ? slideItem.eventPeriodDescription : slideItem.eventDate | date : "dd-MM-YYYY")}}</h3>
                      <h3 class="event-title" *ngIf="slideItem.title">{{externalpageService.getTranslatedTitle(slideItem) | excerpt:30}}</h3>
                      <div class="event-content" *ngIf="externalpageService.getTranslatedContent(slideItem)">
                        <span [innerHTML]="externalpageService.getTranslatedContent(slideItem) | excerpt:120 | striphtml"></span>
                      </div>
                    </div>
                    </a>
                  </div>
                </div>
              </ng-template>
            </ngb-carousel>
          </span>

        </div>

      </div>

    </div>

  </div>

</div>
